"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageWrapper = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _flat = _interopRequireDefault(require("flat"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactIntl = require("react-intl");

var _wtlContext = require("../context/wtl-context");

var _metadata = require("../metadata/metadata");

var _pageH = require("../seo/page-h1/page-h1");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  display: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var PageCloak = _styledComponents["default"].div(_templateObject(), function (p) {
  return p.cloak ? 'none' : 'unset';
});

var PageWrapper =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(PageWrapper, _React$Component);

  function PageWrapper() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, PageWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(PageWrapper)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      cloaked: true
    });
    return _this;
  }

  (0, _createClass2["default"])(PageWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (typeof window !== 'undefined') {
        this.setState({
          cloaked: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$context = this.context,
          config = _this$context.config,
          localeData = _this$context.localeData;
      var _this$props = this.props,
          children = _this$props.children,
          _this$props$skipMetad = _this$props.skipMetadata,
          skipMetadata = _this$props$skipMetad === void 0 ? false : _this$props$skipMetad;
      var cloaked = this.state.cloaked;

      if (typeof localeData === 'undefined') {
        throw new Error('ContextError: Locale No Available');
      }

      var locale;

      if (typeof navigator !== 'undefined') {
        locale = localStorage.getItem('language') || (navigator.languages && navigator.languages[0] || navigator.language || navigator.userLanguage).toLowerCase().split(/[_-]+/)[0];
      } else {
        locale = config.DEFAULT_LOCALE;
      }

      var messages = (0, _flat["default"])(localeData[locale] || localeData[config.DEFAULT_LOCALE]);
      return _react["default"].createElement(PageCloak, {
        cloak: cloaked,
        key: Date.now()
      }, _react["default"].createElement(_reactIntl.IntlProvider, {
        defaultLocale: locale || 'en',
        locale: locale,
        messages: messages
      }, _react["default"].createElement(_react["default"].Fragment, null, skipMetadata === false && _react["default"].createElement(_metadata.Metadata, {
        config: config
      }), children)));
    }
  }]);
  return PageWrapper;
}(_react["default"].Component);

exports.PageWrapper = PageWrapper;
PageWrapper.contextType = _wtlContext.WtlContext;